<template>
  <v-list-item @click="$emit('click', $event)">
    <v-list-item-action class="my-1">
      <h-badged-avatar
        :icon="icon"
        :resource="item"
      />
    </v-list-item-action>
    <v-list-item-content>
      <v-list-item-title
        :class="{'text-body-2': dense}"
        v-text="item.name"
      />
    </v-list-item-content>
    <v-list-item-action-text>
      {{ count | hideZero }}
    </v-list-item-action-text>
  </v-list-item>
</template>

<script>
  import HBadgedAvatar from '@/Components/BadgedAvatar'

  export default {
    components: {
      HBadgedAvatar,
    },

    props: {
      item: {
        required: true,
        type: Object,
      },
      count: {
        required: true,
        type: Number,
      },
      icon: {
        required: false,
        type: String,
      },
      dense: {
        required: false,
        type: Boolean,
        default: false,
      },
    },

    filters: {
      hideZero: v => v || '',
    },
  }
</script>
